(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'studySubpage', {
            templateUrl:  'app/views/study-areas/study-subpage.html',
            controller:   'GenericSubpageController',
            controllerAs: 'vm'
        });
})();
